<template>
  <div>
    <v-container >
      <v-row class="elevation-1">
        <v-col>
          <v-select id="input-text-size"
          class="input-text-size"
            v-model="reportConfig"
            :items="reports"
            item-text="description"
            item-value="config"
            label="Type of report"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showDates')">
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.fromDate"
            label="From Date"
            class="input-text-size"
            :isToggle = "false"
            />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.toDate"
            label="To Date"
            class="input-text-size"
            :isToggle = "false"
            />

        </v-col>
      </v-row>
        <v-row class="elevation-1"
        v-if="showReportConfig('showTaxYears')">
        <v-col cols="6">
               <MultiItemSelect
                class="input-text-size"
                  label="By Tax Year"
                  item-text="taxYear"
                  item-value="taxYear"
                  :item-list="taxYearsList"
                  :items="criteria.taxYears"
                  @selected-items="selectedTaxYears"
                />
        </v-col>
        <v-col cols="6">
              <MultiItemSelect
                class="input-text-size"
                  label="Tax Type"
                  item-text="name"
                  item-value="value"
                  :item-list="taxTypes"
                  :items="criteria.taxType"
                  @selected-items="selectedTaxTypes"
                />
        </v-col>
      </v-row>

      <v-row class="elevation-1"

        >
        <v-col cols="6"
         v-if="showReportConfig('showTaxDistricts')"
        >
          <MultiItemSelect
          class="input-text-size"
            label="By Tax Districts"
            item-text="taxDistrictCodeAndName"
            item-value="districtCode"
            :item-list="taxDistrictList"
            :items="criteria.taxDistricts"
            @selected-items="selectedTaxDistricts"
          />
          </v-col>
          <v-col cols="6"
          v-if="showReportConfig('showAdjustCode')"
          >
          <MultiItemSelect
          class="input-text-size"
            label="By Adjustment Types"
            item-text="name"
            item-value="value"
            :item-list="adjTypesList"
            :items="criteria.adjTypes"
            @selected-items="selectedTaxAdjCode"
          />
        </v-col>
          <v-row>
            <v-col cols="12" v-if="showReportConfig('showFullDetails')">
              <v-checkbox
              label="Print With Details"
              dense
              v-model="criteria.showFullDetails"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" v-if="showReportConfig('showSATaxDistrict')">
              <v-checkbox
              label="Print for all SA tax districts"
              dense
              v-model="criteria.allSATaxdistrict"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" v-if="showReportConfig('showExcludeSATaxDistrict')">
              <v-checkbox
              label="Exclude all SA tax districts"
              dense
              v-model="criteria.excludeSATaxdistrict"
              ></v-checkbox>
            </v-col>
          </v-row>

      </v-row>
      <v-row class="elevation-1" v-if="showReportConfig('showFileFormat')">
        <v-select
          class="ma-4"
          v-model="criteria.format"
          :items="reportFormats"
          label="Report file format"
        ></v-select>
      </v-row>
      <v-row>
        <ReportChip
          :to="reportConfig.route"
          :queryString="queryString"
          :isValid="validateCriteria"
          caption="View Report"
        />
        <AddToCronJobBtn
          v-if="reportConfig.route"
          :destination="reportConfig.route"
          :params="currentCronParams"
          class="ml-2 mt-1"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ReportChip from '../../../reports/ReportChip.vue';
import AddToCronJobBtn from '../../../common/AddToCronJobBtn.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import { queryStringCalc, adjustMentReportList } from './report-util';
import { getRawJwt } from '../../../../util/jwt';
import MultiItemSelect from '../../../common/base/MultiItemSelect.vue';
import { typesDefination } from '../util';
import { toShortDate } from '../../../../util/shared/tmc-global';

const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
const adjTypesBaseCrudKey = 'taxAdjTypesList';

export default {
  name: 'TaxRollAdjustmentReport',
  components: {
    ReportChip,
    AddToCronJobBtn,
    ClarionDateControl,
    MultiItemSelect,
  },
  data: () => ({
    taxYearRange: [],
    criteria: {
      taxDistricts: [],
      adjTypes: [],
      taxYears: [],
      taxType: [],
      fromDate: toShortDate(),
      toDate: toShortDate(),
      showFullDetails: false,
      allSATaxdistrict: false,
      excludeSATaxdistrict: false,
      format: 'pdf',
    },
    reportConfig: {
      route: '',
      filters: {},
    },
    criteriaStats: {
      allTaxDistricts: false,
      allTaxYears: false,
    },
    taxTypes: [],
    defaultCriteria: {
      fy: undefined,
    },
    // taxYearsList: [],
  }),
  created() {
    this.loadTaxDistricts();
    this.initializeTaxYear();
    this.loadTaxTypes();
    this.loadAdjCodes();
  },

  computed: {
    ...mapGetters('base/crud', [
      'items',
    ]),
    ...mapState({
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
    }),
    reports() {
      return [
        ...adjustMentReportList(),
      ];
    },
    taxDistrictList() {
      const items = this.items(taxDistrictBaseCrudKey);
      const updatedItem = items.map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },
    adjTypesList() {
      const items = this.items(adjTypesBaseCrudKey);
      const filterArr = items.filter((ft) => ft.name !== '');
      return [...filterArr];
    },

    queryString() {
      return queryStringCalc({
        reportConfig: this.reportConfig,
        criteria: this.criteria,
        token: this.getAuthToken,
        defaultCriteria: this.defaultCriteria,
        devSetting: this.devSettingItem,
        criteriaStats: this.criteriaStats,
      });
    },
    validateCriteria() {
      let isValid = true;
      if (this.criteria.fy == null) {
        isValid = false;
      }
      return isValid;
    },
    reportFormats() {
      return ['pdf', 'csv'];
    },
    currentCronParams() {
      const c = this.criteria;
      const s = this.criteriaStats;
      return {
        fromDate: c.fromDate,
        toDate: c.toDate,
        taxDistrictCodes: (c.taxDistricts || []).join(','),
        taxYears: (c.taxYears || []).join(','),
        taxType: (c.taxType || []).join(','),
        adjustmentCodes: (c.adjTypes || []).join(','),
        fullDetails: c.showFullDetails,
        allSATaxdistrict: c.allSATaxdistrict,
        excludeSATaxdistrict: c.excludeSATaxdistrict,
        allTaxDistricts: s.allTaxDistricts,
        allTaxTypes: s.allTaxTypes,
        format: c.format || 'pdf',
      };
    },
    getAuthToken() {
      return getRawJwt();
    },
    isVoidOptions() {
      return [
        {
          value: null,
          caption: 'All',
        },
        {
          value: true,
          caption: 'Void',
        },
      ];
    },
  },
  watch: {
    'criteria.allSATaxdistrict': function watchAllSATaxdistrict(val) {
      if (val) this.criteria.excludeSATaxdistrict = false;
    },
    'criteria.excludeSATaxdistrict': function watchExcludeSATaxdistrict(val) {
      if (val) this.criteria.allSATaxdistrict = false;
    },
    reportConfig(newConfig) {
      if (newConfig && newConfig.defaultAdjCodes) {
        this.criteria.adjTypes = newConfig.defaultAdjCodes;
      } else {
        this.loadAdjCodes();
      }
    },
  },
  methods: {
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
    ]),
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    ...mapActions('tax/taxRollAdjustments', [
      'getTaxTypes',
    ]),

    mapCollectionVal(itemList, itemValue) {
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },

    selectedTaxDistricts(val) {
      this.criteria.taxDistricts = val;
    },
    selectedTaxAdjCode(val) {
      this.criteria.adjTypes = val;
    },
    selectedTaxYears(val) {
      this.criteria.taxYears = val;
    },
    selectedTaxTypes(val) {
      this.criteria.taxType = val;
    },

    showReportConfig(configField) {
      return this.reportConfig.filters[configField];
    },
    async loadTaxTypes() {
      const tt = await this.getTaxTypes();
      const updatedItem = [];
      const taxType = [];
      // eslint-disable-next-line array-callback-return
      for (const item of tt) {
        if (item) {
          updatedItem.push({
            name: `${item.toUpperCase()} - ${typesDefination[item] || ''} `, value: item.toUpperCase(),
          });
          taxType.push(item.toUpperCase());
        }
      }
      this.criteria.taxType = taxType;
      this.taxTypes = updatedItem;
    },

    loadTaxDistricts() {
      const criteria = {};
      this.loadTaxDistrict({ criteria, baseCrudKey: taxDistrictBaseCrudKey }).then(() => {
        this.criteria.taxDistricts = this.mapCollectionVal(this.taxDistrictList, 'districtCode');
      });
    },
    async initializeTaxYear() {
      const item = await this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      const data = [];
      const taxYears = [];

      // eslint-disable-next-line array-callback-return
      item.map((val) => {
        data.push({
          taxYear: val,
        });
        taxYears.push(val);
      });
      this.taxYearsList = data;
      this.criteria.taxYears = taxYears;
      return data;
    },
    loadAdjCodes() {
      const adjType = this.adjTypesList;
      this.criteria.adjTypes = adjType.map((item) => item.value);
    },
  },
};

</script>
